<template>
  <div id="app">
    <div>
      <div class="viewport">
        <div class="game">
          <div class="rows">
            <zongzi v-bind:Row="Row1" ref="Row1"></zongzi>
            <zongzi v-bind:Row="Row2" ref="Row2"></zongzi>
            <zongzi v-bind:Row="Row3" ref="Row3"></zongzi>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-mask modal-transition" v-show="diaShow">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h3 slot="header">提示</h3>
          </div>
          <div class="modal-body">游戏结束</div>
          <div class="modal-footer">
            <button class="modal-default-button" @click="repeat">再来一次</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zongzi from "./components/zongzi.vue";

export default {
  name: "App",
  components: {
    zongzi,
  },
  data() {
    return {
      Row1: {
        name: "top",
        index: 0,
        value: 0,
        endValue: 0,
        speed: 200,
        isRunning: true,
        key: Math.random(),
        direction: "ltr",
      },

      Row2: {
        name: "center",
        value: 0,
        index: 1,
        endValue: 0,
        speed: 200,
        isRunning: true,
        key: Math.random(),
        direction: "rtl",
      },

      Row3: {
        name: "bottom",
        value: 0,
        index: 2,
        endValue: 0,
        speed: 200,
        isRunning: true,
        key: Math.random(),
        direction: "ltr",
      },

      prize: "none",
      activeRowIndex: 1,
      diaShow:false
    };
  },
  mounted() {
    window.addEventListener("keypress", () => {
    
        if(this.activeRowIndex===3){
         this.diaShow = true
        }
      if (this.activeRowIndex <= 3) {
        let curRow = this.$refs[`Row${this.activeRowIndex}`];
        console.log(curRow);
        curRow.clearRowInterval();
        this.activeRowIndex++;
      
      } else {
        this.activeRowIndex = 1;
      }
    });
  },
  methods: {
    repeat(){
      this.diaShow=false;
      this.$refs.Row1.startInterval()
      this.$refs.Row2.startInterval()
      this.$refs.Row3.startInterval()
    }
  },
};
</script>

<style>
body {
  font-family: "VT323", sans-serif;
  background: #000000;
}
body:after {
  content: "";
  display: block;
  position: fixed;
  top: 50%;
  right: 18%;
  left: 18%;
  border: 0.5vw solid white;
  bottom: 44%;
  padding-top: 39%;
  transform: translateY(-50%);
  box-sizing: border-box;
}

.helper {
  position: fixed;
  bottom: 1rem;
  z-index: 100;
  color: #fff;
  text-align: center;
  left: 0;
  right: 0;
  pointer-events: none;
  font-size: 3vw;
  opacity: 0.5;
}

.viewport {
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
}
.viewport:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 20%;
  background: #000000;
  z-index: 10;
}
.viewport:after {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 20%;
  background: #000000;
  z-index: 10;
}

.game {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  transform: translateY(-50%);
}
.modal-mask{
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    width: 100%;
    height:100%;
    top:0;
    left: 0;
    z-index: 99;
    display: table;
}
.modal-wrapper{
    display: table-cell;
    vertical-align: middle;
}
.modal-container{
  position: absolute;
    bottom: 0;
    right: 0;
    background-color: white;
    width: 200px;
    padding: 20px 30px;
}
.modal-header h3{
    margin-top: 0;
    color:#42b983;
}
.modal-body{
    margin: 20px 0;
}
.modal-footer{
  height: 20px;
}
.modal-default-button{
    float: right;
}
</style>
